

export default {
  name: 'CounterComponentEntry',
  props: {
    count: {
      type: [String, Number],
    },
    value: {
      type: [String, Number],
    },
    animationDuration: {
      type: [String, Number],
      default: 1.5,
    },
  },
  data() {
    return {
      windowHeight: null,
      isAnimationDone: false,
    };
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      if (this.isAnimationDone) {
        return;
      }
      if (this.$refs.counterEntry.getBoundingClientRect().top <= (this.windowHeight / 2)) {
        this.animateValue(this.$refs.counterValue, 0, this.$refs.counterValue.getAttribute('data-value'));
        this.isAnimationDone = true;
      }
    },
    animateValue(counterElement, start, end) {
      let startTimestamp = null;
      let duration = (parseInt(this.animationDuration) * 1000);
      const step = (timestamp) => {
        if (!startTimestamp) {
          startTimestamp = timestamp;
        }
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        counterElement.innerHTML = Math.floor(progress * (end - start) + start);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    },
  },
};
